import { Button, Flex, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import {
  PACKAGE_ITEM_RESOLUTION,
  PackageItemResolutionString,
} from '@/model/Logistic/PackageItem/PackageItemResolution';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

interface CaseResolutionItemModalProps {
  receptionItem: PackageItem;
  refetch: () => void;
}

const CaseResolutionItemModal = (props: CaseResolutionItemModalProps) => {
  const { receptionItem, refetch } = props;
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Button onClick={() => setOpenModal(true)}>Resolución</Button>
      <Modal
        destroyOnHidden
        open={openModal}
        onCancel={() => setOpenModal(false)}
        title={t('Resolución del ítem')}
        footer={null}>
        <ModalContent
          receptionItem={receptionItem}
          refetch={refetch}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </>
  );
};

interface ModalContentProps {
  receptionItem: PackageItem;
  refetch: () => void;
  closeModal: () => void;
}

const ModalContent = (props: ModalContentProps) => {
  const { t } = useTranslation();
  const { receptionItem, refetch, closeModal } = props;
  const { packageItemRepository } = useRepositoriesContext();
  const [form] = Form.useForm<PackageItem>();
  const resolution = Form.useWatch('resolution_status', form);
  const resolutionStatusOptions = Object.entries(PackageItemResolutionString).reduce<
    { label: string; value: number }[]
  >((options, [k, v]) => {
    if (parseInt(k) === Number(PACKAGE_ITEM_RESOLUTION.RESOLUCION_AUTOMATICA)) {
      return options;
    }

    options.push({
      label: t(v),
      value: parseInt(k),
    });

    return options;
  }, []);

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={receptionItem}
      onFinish={values => {
        const { resolution_status, billing_number } = values;

        void packageItemRepository
          .updatePackageItem(receptionItem.id, { resolution_status, billing_number })
          .then(() => {
            refetch();
            closeModal();
          });
      }}>
      <Form.Item
        label={t('Resolución')}
        name="resolution_status"
        rules={[{ required: true, message: t('Seleccione una resolución') }]}>
        <AntdSelect
          options={resolutionStatusOptions}
          allowClear
          placeholder={t('Seleccione una resolución')}
        />
      </Form.Item>
      {resolution == PACKAGE_ITEM_RESOLUTION.FACTURADO && (
        <Form.Item
          label={t('Número de factura')}
          name="billing_number"
          rules={[{ required: true, message: t('Ingrese el número de factura') }]}>
          <Input placeholder={t('Ingrese el número de factura')} />
        </Form.Item>
      )}
      <Flex justify="end" align="center" gap={8}>
        <Button
          onClick={() => {
            closeModal();
          }}>
          {t('Cancelar')}
        </Button>
        <Button type="primary" htmlType="submit">
          {t('Guardar')}
        </Button>
      </Flex>
    </Form>
  );
};

export default CaseResolutionItemModal;
